var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepCompletedGreenTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7637 25C50.7637 38.805 39.5687 50 25.7637 50C11.9587 50 0.763672 38.805 0.763672 25C0.763672 11.195 11.9587 0 25.7637 0C39.5687 0 50.7637 11.195 50.7637 25Z",
    fill: "url(#paint0_linear_29429_23878)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4588 15.7329L21.2638 30.9459L16.0288 25.7259C15.0518 24.7519 13.4708 24.7529 12.4958 25.7289C11.5188 26.7059 11.5198 28.2909 12.4978 29.2669L19.4998 36.2519C20.4768 37.2269 22.0588 37.2249 23.0338 36.2489L39.9958 19.2669C40.9708 18.2899 40.9708 16.7079 39.9948 15.7319C39.0178 14.7559 37.4348 14.7559 36.4588 15.7329Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29429_23878",
    x1: 25.7637,
    y1: 0,
    x2: 25.7637,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42D778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#34B171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCompletedGreenTick);
export default __webpack_public_path__ + "static/media/StepCompletedGreenTick.c79bddb7986e28ebdf1665f341e21aeb.svg";
export { ForwardRef as ReactComponent };